export const state = () => ({
  isIdentified: false
})

export const getters = {
  /**
   * State for identification in posthog
   * @returns {Boolean}
   */
  isIdentified(state) {
    return state.isIdentified
  }
}

export const mutations = {
  setIsIdentified(state, status) {
    state.isIdentified = status
  }
}
